export default __webpack_public_path__ + "static/media/question_mark3.6bfa16e4.svg";